import { render, staticRenderFns } from "./psReturnExtractionScheme.vue?vue&type=template&id=233b9ee4&scoped=true"
import script from "./psReturnExtractionScheme.vue?vue&type=script&lang=js"
export * from "./psReturnExtractionScheme.vue?vue&type=script&lang=js"
import style0 from "./psReturnExtractionScheme.vue?vue&type=style&index=0&id=233b9ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b9ee4",
  null
  
)

export default component.exports